import { RunJobCard } from '@/features/jobs';
import { t } from '@/lib/i18n';
import { useRecommendedJobs } from '../hooks';
import styles from './WorkHistoryCoach.module.css';

interface Props {
  memberId: string;
  memberName: string;
}

export function WorkHistoryCoach({ memberId, memberName }: Props) {
  const { data } = useRecommendedJobs(memberId);
  const jobs = data?.items ?? [];

  return (
    <section className={styles.coach}>
      <h2 className={styles.headline}>
        {t('What should {name} work on first?', { name: memberName })}
      </h2>

      <div className={styles.grid}>
        {jobs.map((j) => (
          <RunJobCard
            key={j.id}
            templateId={j.id}
            title={j.title}
            description={j.description}
            icon={j.icon}
            prefillMemberId={memberId}
          />
        ))}
      </div>
    </section>
  );
}
